import moment from 'moment';
import Poller from 'backbone-poller';
import { camelCaseToReadable } from 'utils/strings';

import CashFlowReport from 'app/models/cash_flow_report';
import PaymentLogReport from 'app/models/payment_log_report';
import ShipmentReport from 'app/models/shipment_report';
import TrackerReport from 'app/models/tracker_report';
import FulfillmentOrderReport from 'app/models/fulfillment_order_report';

import LoaderView from 'app/views/loader';
import ReportDetailViewBase from 'app/views/report_detail_view_base';

import tmpl from 'templates/report_detail_page';

export default ReportDetailViewBase.extend({
  compiledTemplate: tmpl,
  className: 'report-detail',


  events: {
    'click .download-report': 'downloadReport',
  },

  initialize(options) {
    this.reportType = options.reportType;
    this.reportId = options.reportId;
    this.mode = options.mode;

    const ReportModelClass = this.getReportModelClass(this.reportType);
    this.model = new ReportModelClass({ id: this.reportId, mode: this.mode });

    this.addSubview('reportLoader', '#report_loader', new LoaderView({ type: 'flat' }));
    this.addSubview('reportDownloadLoader', '#report_download_loader', new LoaderView({ type: 'flat' }));

    this.listenTo(this.model, 'sync error', this.render);

    const poller = Poller.get(this.model, { delay: 3000 });
    poller.on('success', (model) => {
      const currentStatus = model.get('status');
      if (currentStatus === 'available' || currentStatus === 'failed') poller.stop();
    });
    poller.on('error', (model, resp) => {
      this.errMsg = resp.responseJSON.error.message;
      poller.stop();
    });
    poller.start();
  },

  context() {
    const date = this.model.escape('created_at');

    return {
      errMsg: this.errMsg,
      id: this.model.escape('id'),
      reportType: this.reportType,
      reportTypeReadable: camelCaseToReadable(this.model.escape('object')),
      createdAtDate: moment(date).format('YYYY-MM-DD'),
      createdAtTime: moment(date).format('hh:mma'),
      startDate: moment(this.model.escape('start_date')).format('YYYY-MM-DD'),
      endDate: moment(this.model.escape('end_date')).format('YYYY-MM-DD'),
      status: this.model.escape('status'),
      url: this.model.escape('url'),  // This field should not be printed/used directly, since these urls expire very quickly
    };
  },

  getReportModelClass(type) {
    return {
      cash_flow: CashFlowReport,
      payment_log: PaymentLogReport,
      shipment: ShipmentReport,
      tracker: TrackerReport,
      fulfillment_order: FulfillmentOrderReport,
    }[type];
  },
});



// WEBPACK FOOTER //
// ./app/views/report_detail_page.js